<script setup lang="ts">
import { useUserProfile } from '@auth/useProfile';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FadeSlideTransition from '@shared/animation/transitions/FadeSlideTransition/FadeSlideTransition.vue';

const { userProfile } = useUserProfile();
</script>
<template>
  <FadeSlideTransition direction="down" mode="out-in">
    <div
      v-if="userProfile?.impersonated === true"
      class="sticky top-[var(--header-height,0px)] z-subheader flex min-h-10 items-center justify-center gap-2 border-0 border-b border-solid border-orange-300 bg-orange-200 px-4 py-2 text-center text-sm text-primary-900 shadow-sm"
      role="status"
    >
      <FontAwesomeIcon class="text-orange" :icon="['far', 'user-secret']" />
      <div>
        Ingelogd als
        <span class="font-bold">{{ userProfile.fullName ?? 'andere gebruiker' }}</span> van
        <span class="font-bold">{{ userProfile.tussenPersoon }}</span
        >.
        <span class="hidden sm:inline">Je handelt met de rechten van deze gebruiker.</span>
      </div>
    </div>
  </FadeSlideTransition>
</template>
